import { bubEvents } from 'shared/events/bub_events';

$(() => {
  const menuToggle = $('.browse-link, .browse-all');
  const menuToggleLink = $('.common-link.browse-audiobooks, .common-link.browse-all-link');
  const menuToggleIcon = $('.browse-link-icon, .browse-all-link-icon');
  const overlay = $('.browse-overlay');
  const menu = $('.browse-dropdown-wrapper');

  let menuOpen = false;

  function openDropdown() {
    menuOpen = true;

    menu.attr('aria-hidden', false);
    overlay.addClass('active');
    menu.addClass('active');
    menuToggleIcon.addClass('arrow-up');
    if (window.innerWidth === document.body.clientWidth) {
      $('body').css('overflow', 'hidden');
    }
  }

  function closeDropdown() {
    menuOpen = false;

    menu.attr('aria-hidden', true);
    overlay.removeClass('active');
    menu.removeClass('active');
    menuToggleIcon.removeClass('arrow-up');
    $('body').css('overflow', '');
  }

  function onClickMenuToggle() {
    if (!menuOpen) {
      openDropdown();
    } else {
      closeDropdown();
    }

    bubEvents.track('Header', 'Clicked nav', {
      label: 'all categories',
      value: menuOpen ? 'open' : 'close',
    });
  }

  function isClickOutsideMenu(targetElement) {
    return menu.has(targetElement).length === 0;
  }

  function isClickOnMenuToggle(targetElement) {
    return menuToggle.is(targetElement) || menuToggleIcon.is(targetElement) || menuToggleLink.is(targetElement);
  }

  function browseItemSectionTitle(event) {
    return $(event.currentTarget)
      .parents('.browse-dropdown-section')
      .first()
      .children('.browse-dropdown-section-title')
      .first()
      .text()
      .trim()
      .toLowerCase();
  }

  $(document).on('click touch', event => {
    if (
      menuOpen &&
      !isClickOnMenuToggle(event.target) &&
      (isClickOutsideMenu(event.target) || $('.browse-mobile-cancel').is(event.target))
    ) {
      closeDropdown();
    }

    if (isClickOnMenuToggle(event.target)) {
      onClickMenuToggle();
    }
  });

  // HACK: Touch events on mobile fire a series of events (touchstart...touchend, mousemove, ..., click)
  // We only want mouseover events to fire from desktop/non-touch events so add this handler to
  // short-circuit the event chain.  When a touch event fires, fire a click, and then preventDefault to halt events
  // See https://developer.mozilla.org/en-US/docs/Web/API/Touch_events/Supporting_both_TouchEvent_and_MouseEvent
  menuToggle.on('touchend', event => {
    event.target.click();
    event.preventDefault();
  });

  $('.browse-dropdown-section-categories .browse-dropdown-section-link').click(event => {
    bubEvents.track('Browse', 'Clicked link', {
      label: browseItemSectionTitle(event),
      value: event.currentTarget.text,
    });
  });

  $('.browse-dropdown-section-explore .browse-dropdown-section-link-explore').click(event => {
    bubEvents.track('Browse', 'Clicked link', {
      label: browseItemSectionTitle(event),
      value: event.currentTarget.text,
    });
  });
});
